import type { ClientDeviceWithDevice } from '@maru44/huntre-utils/src/models/clientDevice'
import { CommunicationStatus, communicationStatus } from '@maru44/huntre-utils/src/models/communicationStatus'
import { type Sim, SimProvider } from '@maru44/huntre-utils/src/models/sim'
import { Box, Typography } from '@mui/material'
import type { FC } from 'react'
import { IconPopover } from 'src/components/atoms/IconPopover'
import { StatusChip } from 'src/components/atoms/StatusChip'
import { formatTimestampToDate } from 'src/utils/firebase'

type Props = {
  data: ClientDeviceWithDevice
  sim: Sim | null
}

export const Communication: FC<Props> = ({ data, sim }) => {
  const simStatus = communicationStatus(data.device, sim)

  if (!simStatus) {
    return <>loading...</>
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
      }}
    >
      <StatusChip status={simStatus} />
      {simStatus === CommunicationStatus.Ok && sim?.provider === SimProvider.Soracom && (
        <Typography>{sim?.expiresAt ? `期限: ${formatTimestampToDate(sim.expiresAt)}` : '無期限'}</Typography>
      )}
      {sim?.provider === SimProvider.Once && (
        <IconPopover icon="?">
          <Typography>
            通信は一定の通信量が(概算10年間)ご利用いただけます。
            <br />
            現在通信の更新フォームを作成しております。万が一通信量が上限に達しましたらお問合せください。
          </Typography>
        </IconPopover>
      )}
    </Box>
  )
}
